export const calendarFormat = {
    sameDay: '[Vandaag om] HH:mm',
    nextDay: '[Morgen om] HH:mm',
    nextWeek: 'dddd [om] HH:mm',
    lastDay: '[Gisteren om] HH:mm',
    lastWeek: 'dddd [om] HH:mm',
    sameElse: 'DD MMMM [om] HH:mm'
}